(function () {
  function initDescriptionBrief(root) {
    const wrap = root.querySelector('[data-setara-description-brief]');
    if (!wrap) return;

    const content = wrap.querySelector('[data-setara-description-content]');
    const toggle = wrap.querySelector('[data-setara-description-toggle]');
    const moreLabel = wrap.querySelector('[data-setara-description-toggle-more]');
    const lessLabel = wrap.querySelector('[data-setara-description-toggle-less]');

    if (!content || !toggle) return;

    const update = () => {
      content.classList.add('is-clamped');
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (moreLabel) moreLabel.hidden = false;
      if (lessLabel) lessLabel.hidden = true;

      const needsToggle = content.scrollHeight > content.clientHeight + 1;
      if (!needsToggle) {
        content.classList.remove('is-clamped');
        return;
      }

      toggle.hidden = false;
    };

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !expanded;

      toggle.setAttribute('aria-expanded', String(nextExpanded));
      content.classList.toggle('is-clamped', !nextExpanded);
      if (moreLabel) moreLabel.hidden = nextExpanded;
      if (lessLabel) lessLabel.hidden = !nextExpanded;
    });

    update();
    window.addEventListener('resize', update);
  }

  function boot(scope) {
    scope.querySelectorAll('[data-setara-ingredients-brief]').forEach(initDescriptionBrief);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
